<template>
  <div>
    <ValidationObserver ref="obs">
      <v-card flat class="pa-4" color="#1e1e1e" elevation="2" slot-scope="{ invalid, validated }">
        <v-card-title class="text-h6 text-white">
          {{ title }}
        </v-card-title>

        <v-card-text>
          <v-col cols="12" class="pa-0">
            <VTextFieldWithValidation
              rules="required|max:50"
              v-model="categoria.name"
              autofocus
              :counter="50"
              label="Nombre"
              name="Nombre"
              @keyup.enter="validateForm('form-categoria')"
            />
          </v-col>

          <v-col cols="12" class="pa-0 mt-2">
            <v-select
              v-model="uso"
              :items="usoOptions"
              item-text="text"
              item-value="value"
              label="Uso"
              outlined
              dense
              dark
              hide-details
            ></v-select>
          </v-col>

          <v-col v-if="withColor" class="d-flex justify-center mt-4 pa-0">
            <v-color-picker
              type="hex"
              hide-inputs
              v-model="color"
              flat
              class="bg-grey-darken-4 rounded-lg"
            />
          </v-col>
        </v-card-text>

        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>

          <v-btn
            rounded
            variant="text"
            color="grey"
            @click="$emit('cerrar-dialog')"
          >
            Cancelar
          </v-btn>

          <v-btn
            rounded
            color="grey darken-2"
            class="white--text"
            @click="validateForm('form-categoria')"
            :disabled="invalid || !validated"
          >
            {{ nameButton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </div>
</template>



<script>
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "@/components/inputs/VTextFieldWithValidation";

const USO_OPTIONS = [
  { value: 'ambos', text: 'Ambos' },
  { value: 'venta', text: 'Venta' },
  { value: 'compra', text: 'Compra' },
];

export default {
  name: "FormInputCategoria",
  $_veeValidate: {
    validator: "new",
  },
  components: { ValidationObserver, VTextFieldWithValidation },

  props: {
    categoria: {
      type: Object,
      required: false,
    },
    categoriaPadre: {
      type: Object,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: "Nueva categoría",
    },
    nameButton: {
      type: String,
      required: false,
      default: "Registrar",
    },
    withColor: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      color: "#FF00FF",
      uso: 'ambos',
    };
  },
  computed: {
    usoOptions() {
      const parentUso = this.categoriaPadre?.uso;
      if (!parentUso || parentUso === 'ambos') {
        return USO_OPTIONS;
      }
      return USO_OPTIONS.filter(o => o.value === parentUso);
    },
  },
  watch: {
    uso() {
      this.$nextTick(() => this.$refs.obs.validate());
    },
  },
  methods: {
    getRandomColor() {
      if (this.categoria.color) {
        this.color = this.categoria.color;
        return;
      }
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      this.color = color;
      return;
    },
    async validateForm(scope) {
      const result = await this.$refs.obs.validate();
      if (result) {
        if (this.withColor) {
          this.categoria.color = this.color;
        }
        // eslint-disable-next-line
        this.$emit("processCategoria", { ...this.categoria, uso: this.uso });
        this.$validator.reset();
        // call form submission logic
      } else {
        this.$validator.validate();
      }
    },
  },
  created() {
    this.getRandomColor();
    if (this.categoria && this.categoria.uso) {
      this.uso = this.categoria.uso;
    } else if (this.categoriaPadre && this.categoriaPadre.uso && this.categoriaPadre.uso !== 'ambos') {
      this.uso = this.categoriaPadre.uso;
    }
  },
};
</script>

<style lang="scss" scoped></style>
